/**
 * Sinal de "sessão expirada" entre a renovação do login (apiClient) e a tela de login.
 *
 * Quando a sessão cai, o sistema recarrega a página e manda a pessoa para o login.
 * Sem este sinal, ela chega ali sem saber o motivo. O sinal vive só na aba
 * (sessionStorage) e é apagado depois de lido. Se o navegador bloquear o
 * armazenamento, a tela de login segue normal, só sem a explicação.
 */
const CHAVE = 'sj_sessao_expirou';

export function marcarSessaoExpirada() {
  try {
    sessionStorage.setItem(CHAVE, '1');
  } catch (_) {
    // Navegador sem sessionStorage: segue sem a explicação.
  }
}

export function sessaoFoiExpirada() {
  try {
    return sessionStorage.getItem(CHAVE) === '1';
  } catch (_) {
    return false;
  }
}

export function apagarSinalDeSessaoExpirada() {
  try {
    sessionStorage.removeItem(CHAVE);
  } catch (_) {
    // Nada a apagar.
  }
}

/*
 * Sessão expirada como diálogo sobre a tela (Estados.dc.html, 31/10/2026).
 *
 * Quando a renovação falha, o apiClient pede uma nova entrada a quem estiver
 * ouvindo (o diálogo da casca). Os pedidos que caíram esperam a promessa: com a
 * senha certa, recebem o token novo e são refeitos; nada da tela se perde. Sem
 * ninguém ouvindo (tela de login, Bunker, testes), vale o caminho antigo:
 * marca o motivo, limpa e recarrega.
 */
let ouvinte = null;

export function ouvirSessaoExpirada(fn) {
  ouvinte = fn;
  return () => { if (ouvinte === fn) ouvinte = null; };
}

/** Devolve a promessa do token novo, ou null se ninguém pode pedir a senha. */
export function pedirNovaEntrada(usuario) {
  if (!ouvinte || !usuario?.email) return null;
  const avisar = ouvinte;
  return new Promise((concluir, desistir) => avisar({ usuario, concluir, desistir }));
}
